module.exports = __webpack_public_path__ + "img/reviews.2d72e9de.svg";